import { Reducer } from '@reduxjs/toolkit';

import Action from 'lib/interfaces/Action';

export type ResetStateActions = Action<ResetStateActionType.ResetState>;

export enum ResetStateActionType {
  ResetState = 'reset/RESET_STATE',
}

export const resetState = (): Action<ResetStateActionType.ResetState> => ({
  type: ResetStateActionType.ResetState,
});

/**
 * "Infrastructural", non-business state needed for app to run. Currently empty.
 */
interface CoreState {}

/**
 * A Redux reducer decorator that adds an action to reset all state.
 */
const withResetState =
  <S extends CoreState>(
    decoratedReducer: Reducer<S, Action>,
  ): Reducer<S, Action | ResetStateActions> =>
  (state, action) => {
    switch (action.type) {
      case ResetStateActionType.ResetState: {
        const initialState = decoratedReducer(undefined, action);
        // Put any state that should be kept even after logout here, e.g. geolocation data
        const retainedState: CoreState = {};

        return {
          ...initialState,
          ...retainedState,
        };
      }
      default: {
        // Do nothing
        return decoratedReducer(state, action);
      }
    }
  };

export default withResetState;
